<script setup>
/******************************************************************************
 * Component footer
 *****************************************************************************/
import { CLIENT_FULL, URLS } from "@/config";
</script>

<template>
    <footer>
        <a class="footer-link" :href="URLS.website" target="_blank">{{
            CLIENT_FULL
        }}</a>
        <nav>
            <a class="footer-link" :href="URLS.privacy" target="_blank"
                >Datenschutz</a
            >
            <a class="footer-link" :href="URLS.imprint" target="_blank"
                >Impressum</a
            >
            <a
                class="footer-link"
                href="https://www.stadtwerke-norderstedt.de/barrierefreiheit"
                target="_blank"
                >Barrierefreiheit</a
            >
        </nav>
    </footer>
</template>

<style lang="scss" scoped>
footer {
    border-top: get($client, "footerBorder");

    background-color: get($client, "footerBg");

    @include respond-to("medium") {
        display: flex;
        justify-content: space-between;
    }

    a {
        display: inline-block;
        position: relative;

        padding: #{get($sizes, "base") * 0.5};

        color: get($client, "footerColor");

        transition: background-color get($timings, "fast") linear;

        &:hover {
            background-color: color.adjust(
                get($client, "footerBg"),
                $lightness: -10%
            );
        }
    }
}

nav a:not(:first-child)::before {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 0;

    width: 1px;
    height: #{get($sizes, "base") * 1.25};

    transform: translateY(-50%);

    background: color.adjust(get($client, "footerColor"), $lightness: -20%);

    content: "";
}
</style>
